import React, { useEffect, useState } from 'react';
import deleteImg from '../images/delete.svg'
import interrogationImg from '../images/interrogation.svg'
import GreenSwitch from './GreenSwitch';
import { useSelector, useDispatch } from 'react-redux';
import { updatePrice, updatePeriodo, updateResumenProperty, updatePrivacyProtection, updatePrivacyProtectionPrice, updateDomainPromo, setHayNbps } from '../globalslice';
import { removeResumenData, setDescuentoTotal } from '../globalslice';
import Swal from 'sweetalert2'
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import '../styles/CartItems.scss';
import { useTranslation } from 'react-i18next';
import { fetchRemovedomain } from '../services/SearchDomain';
import getDomainPrices from '../services/PriceDomain';
import isProductWithHosting from '../helpers/isProductWithHosting';
import calculatePriceDetails from '../services/calculatePriceDetails';
import { removeDomainFromService } from '../helpers/domainHelper';
import formatAmount from '../helpers/formatAmount';

const ProductDescription = ({ description }) => {
    return (
        <div className='product-description' dangerouslySetInnerHTML={{ __html: description }} />
    );
};

const updateDataAfterServiceRemoval = (data, serviceIdToRemove, dispatch) => {
// Filtra los servicios que no son de tipo "domain" y no tienen el ID que quieres eliminar
let domainDelete = false;
const serviceToRemove = data.find(
    (item) => item.id === serviceIdToRemove && item.type !== "domain"
);
const updatedData = data.filter((item) => item.id !== serviceIdToRemove);

if (
    serviceToRemove &&
    serviceToRemove.product &&
    serviceToRemove.product.domain_section &&
    serviceToRemove.product.domain_section.length > 0
) {
    domainDelete = serviceToRemove.product.domain_section[0].dominio_principal;
}

if (serviceToRemove && domainDelete) {
    // Iterar sobre los servicios de tipo "domain"
    updatedData.forEach((item) => {
    if (item.type === "domain") {
        const relatedDomain = item.product.domain_section[0].dominio_principal;
        // Si hay un dominio relacionado, actualiza el precio
        if (relatedDomain == domainDelete && item.selectPeriodsWithout) {
        let newPrice =
            item.selectPeriodsWithout && item.selectPeriodsWithout[1]
            ? {
                cost: item.selectPeriodsWithout[1].cost,
                cross_price: item.selectPeriodsWithout[1].cross_price,
                second_price: formatAmount(item.selectPeriodsWithout[1].second_price),
                }
            : null;
        if (newPrice) {
            dispatch(updatePrice({ id: item.id, newPrice }));
            dispatch(
            updateResumenProperty({
                id: item.id,
                property: "periodo",
                value: "1 año (s)",
            })
            );
            dispatch(
            updateResumenProperty({
                id: item.id,
                property: "selectPeriods",
                value: item.selectPeriodsWithout,
            })
            );
            dispatch(
            updateResumenProperty({
                id: item.id,
                property: "selectPeriodsWithout",
                value: null,
            })
            );
        }
        } else {
        //Para transferencias de dominio ligados a un hosting actualiza el precio
        if (
            relatedDomain == domainDelete &&
            item.product.domain_section[0].domain_type == "transfer"
        ) {
            let newPrice = {
            cost: item.price.second_price,
            cross_price: false,
            second_price: formatAmount(item.price.cost),
            };
            if (newPrice) {
            dispatch(updatePrice({ id: item.id, newPrice }));
            }
        }
        }
    }
    });
}

return;
};

const changeZIndexSweetAlertOpenModal = (modalElement) => {
    // Determinar el z-index más alto en la página
    const highestZIndex = Array.from(document.querySelectorAll("*"))
      .map((el) => parseFloat(window.getComputedStyle(el).zIndex) || 0)
      .reduce((max, current) => Math.max(max, current), 0);
  
    // Asignar un z-index más alto al modal
    modalElement.style.zIndex = highestZIndex + 10;
    const backdrop = document.querySelector(".swal2-backdrop-show");
    if (backdrop) {
      backdrop.style.zIndex = highestZIndex + 9;
    }
};

export const handleRemoveItem = (globalState, data, dispatch, t) => {
    const { ResumenData, descuentoTotal, resultadosPromos } = globalState;
    let porcentajeDescuento, descuentototalocal = null;
    
    Swal.fire({
        title: t("swal.cart.uSure"),
        text: t("swal.cart.item.clearProduct"),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText:  t("swal.cart.item.delete"),
        cancelButtonText: t("swal.cart.cancel"),
        reverseButtons: true,
        customClass: {
            confirmButton: 'btn-red',
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: changeZIndexSweetAlertOpenModal
    }).then((result) => {
        if (result.isConfirmed) {
            // data = {"product":{"name":"Registro de dominio","smallname":"Registro de dominio","description":"","domain_section":[{"dominio_principal":"unhostingporahi.com","domain_type":"register"}],"privacy_protection":true},"price":{"cost":"199.90","second_price":"199.90","cross_price":false,"privacy_cost":"149.90","privacy_period":"1 año (s)","default_privacy_cost":"149.90"},"periodo":"1 año (s)","id":2,"indexFeedW":0,"actual":false,"type":"domain","selectPeriods":{"1":{"cost":"199.90","cross_price":false,"second_price":"199.90"},"2":{"cost":"399.80","cross_price":false,"second_price":"399.80"},"3":{"cost":"599.70","cross_price":false,"second_price":"599.70"},"4":{"cost":"799.60","cross_price":false,"second_price":"799.60"},"5":{"cost":"999.50","cross_price":false,"second_price":"999.50"},"6":{"cost":"1199.40","cross_price":false,"second_price":"1,199.40"},"7":{"cost":"1399.30","cross_price":false,"second_price":"1,399.30"},"8":{"cost":"1599.20","cross_price":false,"second_price":"1,599.20"},"9":{"cost":"1799.10","cross_price":false,"second_price":"1,799.10"},"10":{"cost":"1999.00","cross_price":false,"second_price":"1,999.00"}},"selectPeriodsWithout":{"1":{"cost":"199.90","cross_price":false,"second_price":"199.90"},"2":{"cost":"399.80","cross_price":false,"second_price":"399.80"},"3":{"cost":"599.70","cross_price":false,"second_price":"599.70"},"4":{"cost":"799.60","cross_price":false,"second_price":"799.60"},"5":{"cost":"999.50","cross_price":false,"second_price":"999.50"},"6":{"cost":"1199.40","cross_price":false,"second_price":"1,199.40"},"7":{"cost":"1399.30","cross_price":false,"second_price":"1,399.30"},"8":{"cost":"1599.20","cross_price":false,"second_price":"1,599.20"},"9":{"cost":"1799.10","cross_price":false,"second_price":"1,799.10"},"10":{"cost":"1999.00","cross_price":false,"second_price":"1,999.00"}}}
        //Si fue servicio que tenia ya un dominio principal, hay que cambiar los precios del dominio
        if(data.type !== 'domain'){
            if(data.type == 'nbps'){
                dispatch(setHayNbps(false));
            }
            updateDataAfterServiceRemoval(ResumenData, data.id, dispatch);
        } else {
            //Si se borra un dominio y tenía un hosting relacionado se actualiza el dominio del hosting a pendiente
            removeDomainFromService(ResumenData, data, dispatch);

            // si es un dominio
            if (typeof window.NBXDeletedDomainCart !== "undefined" && data?.product?.domain_section[0]?.dominio_principal && data?.product?.domain_section[0]?.domain_type) {
                const domain = data?.product?.domain_section[0]?.dominio_principal;
                const type = data?.product?.domain_section[0]?.domain_type;
                // agregamos el dominio para poder remover desde v4
                window.NBXDeletedDomainCart.add(domain, type);
            }
        }
        if (data?.indexFeedW !== undefined && data?.indexFeedW !== null) {
            console.log("Removeitem from indexFeedW")
            // Elimina el item del feed/cartnumitemsjson.php de W
            // https://clientes.neubox.xyz/cart.php?ajax=1&a=remove&r=d&i=0
            fetchRemovedomain(data.product.domain_section[0].dominio_principal)
        }
        dispatch(removeResumenData(data.id));
        //calculamos descuento nuevamente
        if( descuentoTotal != 0){         
            if (resultadosPromos.success == 'success') {
                Object.entries(resultadosPromos.datos).forEach(([id, descuentof]) => {
                    ResumenData.forEach(resumen => {
                      if(resumen.id == id && descuentof.type == "Percentage" && data.id != resumen.id){
                        porcentajeDescuento = parseFloat(resumen.price.second_price.replace(/,/g, '')) * ( parseFloat(descuentof.descuento) / 100);
                        descuentototalocal += porcentajeDescuento;
                        dispatch(setDescuentoTotal(descuentototalocal));
                      } else if(resumen.id == id && descuentof.type == "Fixed Amount" && data.id != resumen.id) {
                        descuentototalocal += parseFloat(descuentof.descuento);
                        dispatch(setDescuentoTotal(descuentototalocal));
                      } else if(resumen.id == id && descuentof.type == "Price Override" && data.id != resumen.id){
                        const priceProduct = parseFloat(String(resumen.price.second_price).replaceAll(',',''));
                        const priceDesc = parseFloat(descuentof.descuento);
                        descuentototalocal += priceProduct - priceDesc;
                        dispatch(setDescuentoTotal(descuentototalocal));
                      } 
                  });
                });
              }
          }                        
        Swal.fire({
            title: t("swal.cart.success"),
            text: t("swal.cart.item.deleteSuccess"),
            icon: 'success',
            confirmButtonText: 'OK',
            timer: 2000,
            timerProgressBar: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: changeZIndexSweetAlertOpenModal
        });
        }
    });
};

const CartListItem = ({ data, ResumenData }) => {
    const { t } = useTranslation();
    const globalState = useSelector(state => state.global);
    const dispatch = useDispatch();
    const currency = useSelector((state) => state.global.currency);
    const [selectedValue, setSelectedValue] = useState(data.periodo || '');

    let selectPeriods = data.selectPeriods;
    //Convierte en array los periodos de dominio y hosting para mostrar en el select
    if (!Array.isArray(data.selectPeriods)) {
        selectPeriods = Object.keys(data.selectPeriods).map(key => {
            if (data.type === 'domain') {
                return {
                    [`${key} año (s)`]: data.selectPeriods[key]
                };
            } else {
                return {
                    [`${key}`]: data.selectPeriods[key]
                };
            }
            
          });
    }

    useEffect(() => {
      const abortController = new AbortController();

      const updateOXPriceDomain = async () => {
        // si el producto no es un OX ó no es un WordPress
        if (! data?.isOX && !data?.isWP ) {
          return false;
        }

        const domain = data?.product?.domain_section[0]?.dominio_principal ?? "";
        const itemDomain = await ResumenData.filter(
          (item) => item.type === "domain" && item?.product?.domain_section[0]?.dominio_principal === domain
        );
        // si se encontró el dominio
        if (itemDomain.length > 0) {
          let domainPrice;
          const id = itemDomain[0]?.id;
          const typeDomainRegister = data?.product?.domain_section[0]?.domain_type;
          const dominioCambiarPeriod = parseInt(String(itemDomain[0]?.periodo).match(/\d+/)[0], 10);
          const domainPriceSin = await getDomainPrices({ domain, currency, type: "solo", typeDomainRegister }, abortController.signal);

          // si el dominio cuenta con hosting gratis, se obtienen los precios desde backend
          if (isProductWithHosting(data)) {
            const productId = data?.product?.id ?? 0;
            domainPrice = await getDomainPrices({ domain, currency, type: "con", typeDomainRegister, productId }, abortController.signal);
          } else {
            // si el producto no cuenta con hosting gratis, se asigna el resultado de precio sin hosting
            domainPrice = domainPriceSin;
          }

          // verificamos que los precios sean correctos
          if (domainPrice && domainPriceSin) {
              const { newPrice, selectPeriods, selectPeriodsWithout } = calculatePriceDetails(domainPrice, domainPriceSin, dominioCambiarPeriod);
    
              dispatch(updatePrice({ id, newPrice }));

              // los dominios de transferencia se limitan a un año las periodicidades
              if (typeDomainRegister !== 'transfer') {
                dispatch(updateResumenProperty({ id, property: "selectPeriods", value: selectPeriods }));
                dispatch(updateResumenProperty({ id, property: "selectPeriodsWithout", value: selectPeriodsWithout }));
              }
          }
        }
      };

      updateOXPriceDomain();

      return () => {
        abortController.abort();
      };
    }, [data?.periodo]);
    

    // Handle the switch toggle
    const handleSwitchChange = (id, event) => {
        const newStatus = event.target.checked; // true for 'on', false for 'off'
        
        // Dispatch action to update status in Redux store
        dispatch(updatePrivacyProtection({ id, newStatus }));
    };

      const handleOptionChange = (event, period) => {
        const periodo = event.target.value
        setSelectedValue(periodo);

        //Establece nuevo precio de privacidad de dominio
        const resultado = periodo.match(/\d+/); // Busca un número en la cadena
        const year =  resultado ? parseInt(resultado[0], 10) : periodo; // Devuelve el número o el periodo si no hay coincidencias

        if(data.type === 'domain' && data.price.default_privacy_cost){
            let newPrivacyCost = (year * parseFloat(data.price.default_privacy_cost)).toFixed(2);
            dispatch(updatePrivacyProtectionPrice({ id: data.id, newPrice: newPrivacyCost, newPeriod: periodo}));
        }

        const currentPeriod = Object.keys(period).map(item => ({
            item,
            ...period[item]
          }));
         
        let  newPrice = {
            cost: currentPeriod[0].cost,
            cross_price: currentPeriod[0].cross_price,
            second_price: formatAmount(currentPeriod[0].second_price)
          };

        dispatch(updatePrice({ id: data.id, newPrice }));
        dispatch(updatePeriodo({ id: data.id, periodo}));
      };

    return (
        <div className='cart-list-content'>
            <div className="cart-list-item" style={{ maxHeight: data.type == 'nbps' ? '50px': ''}}>
                <div className="product-column">
                    <p>{data.product.name}</p>
                    <ProductDescription description={data.product.description ?? null} />
                    {(data.product.description !== null && data.product.description !== '' && data.type !== 'emailmkt') ? <br /> : null} 
                    <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
                    {data.product.domain_section.map((item, index) => {
                        const key = Object.keys(item)[0];
                        return  (
                            <li className='domain-section domain-section-mobile' key={index}>
                            {/* Renderiza información de SO si existe (VPS) */}
                            {item.so && (
                                <div>
                                <strong>SO </strong>
                                <a style={{ color: '#437EF7', fontWeight:600 }}> »  {item.so}</a>
                                </div>
                            )}
                    
                            {/* Renderiza información de Panel Admin si existe (VPS) */}
                            {item.panel_admin && (
                                <div>
                                <strong>Panel de Admin </strong>
                                <a style={{ color: '#437EF7', fontWeight:600 }}> »  {item.panel_admin}</a>
                                </div>
                            )}

                            {/* Condiciones para dominio principal */}
                            {data.type !== 'emailmkt' && ( /* Los productos de emailmtk gid=5 NO muestran dominio */
                            data.type === 'hosting' || data.type === 'vps' ? (
                                <>
                                <strong>
                                    {item[key] === null ? t("cart.associateDomain") : t("cart.mainDomain")}
                                </strong>
                                {item[key] === null ? (
                                    /* Renderiza dominio asociado Pendiente por asignar */
                                    <b style={{ color: '#F79E1B' }}>» {t("cart.pendingDomain")}</b>
                                ) : (
                                /* Renderiza dominio principal dominio.com */
                                <a className="cart-domain-main" id="link">
                                    <span className="cart-domain-main-text">
                                    {data.type != 'nbps' && (
                                        '»'
                                    )} 
                                    {item[key]}</span>
                                </a>
                                )}
                                </>
                            ) : (
                                /* Renderiza dominio solo */
                                <>
                                <div className="cart-domain-wrapper domain-section-mobile2">
                                    <a className="cart-domain-main" id="link">
                                    <span className="cart-domain-main-text">
                                        {data.type != 'nbps' && (
                                            '»'
                                        )} 
                                        {item[key]}</span>
                                    </a>
                                </div>
                                </>
                            )
                            )}
                        </li>
                        );
                    })}
                    </ul>

                    
                </div>
                <div className='items-period-price'>
                    <div className="column">
                    {selectPeriods.length > 0 && data.type != 'nbps' &&(
                        <FormControl fullWidth>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectedValue}
                                sx={{fontSize: '0.875em', maxWidth: '120px'}}
                                onChange={(event) => {
                                    const selectedPeriod = selectPeriods.find(
                                        (item) => Object.keys(item)[0] === event.target.value
                                    );
                                    handleOptionChange(event, selectedPeriod);
                                    }}
                            >
                                {selectPeriods.map((item, index) => {
                                    const key = Object.keys(item)[0];
                                    const value = item[key];
                                    return (
                                    <MenuItem key={index} value={key}>
                                        {key}
                                    </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                        )}
                        {data.type == 'nbps' && (
                            <FormControl fullWidth>
                                <div className='nbp-unica'>
                                    Compra única
                                </div>
                            </FormControl>
                        )}  
                    </div>
                    <div className="price-column">
                        ${data.price.second_price} {currency}
                        
                        {data.price.cross_price && data.price.cost ? (
                        <p className="second-price cross">${data.price.cost} {currency}</p>
                        ) : (
                        <p></p>
                        )}
                    </div>
                </div>
                <div className="last-col">
                    <img src={deleteImg} alt="Eliminar item" height="28px" width="28px" onClick={()=> {handleRemoveItem(globalState, data, dispatch, t)}}></img>
                </div>
            </div>
            <div className="cart-list-item">
                {/* Renderiza Check con privacidad de dominio, 
                establecemos 200 de width pq equivale al (45% * 2) de la primera columna(productos) y llegue a la col de precio
                */}
                {data.price.privacy_cost && data.price.privacy_period ?
                    <div className='item-privacy'>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                            <div className='privacy-button'>
                            <GreenSwitch
                                checked={data.product.privacy_protection} 
                                onChange={(event) => handleSwitchChange(data.id, event)}
                                />
                                <p className='privacy-section'>{t("myCart.privacyProtect")} {data.price.privacy_period}</p>
                            </div>
                            <p className='privacy-section_f16'>${data.price.privacy_cost}{currency}</p>
                        </div>
                        <div className='disclaimer'>
                            <img src={interrogationImg} alt="question icon" height="14px" width="14px"/>
                            <p>{t("myCart.disclaimer")}</p>
                        </div>
                    </div>
                : null
                }
            </div>
        </div>
    );
};

export default CartListItem;
